module.exports = __webpack_public_path__ + "img/mobile-rotate.ae28cfdc.png";